<template>
  <div
    class="notify-wrapper"
    :class="visible ? 'visible':''"
  >
    <div
      class="notify-container row"
      :class="notification.type"
    >
      <div class="col text-col">
        <div class="text">
          {{ notification.message }}
        </div>
      </div>
      <div class="col">
        <div
          class="cross"
          @click="close"
        >
          <span class="fas fa-times"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from './../stores';
  import { NotificationActions } from './../stores/notification.store';

  const DISPLAY_TIME = 5000;

  export default {
    name: 'Notify',
    data() {
      return {
        notification: {},
        timeout: null,
        visible: false,
        ready: true,
      };
    },
    computed: {
      notificationUpdate() {
        return store.state.notification.changes;
      }
    },
    watch: {
      notificationUpdate() {
        if (this.ready) {
          this.processNext();
        }
      }
    },
    beforeDestroy() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
    },
    methods: {
      createNotification(notification) {
        this.ready = false;
        this.notification = notification;
        this.visible = true;
        this.timeout = window.setTimeout(() => {
          this.close();
          this.timeout = null;
        }, DISPLAY_TIME);
      },
      processNext() {
        const notification = store.getters.getNextNotification();
        if (notification) {
          this.createNotification(notification);
        }
      },
      close() {
        store.dispatch(NotificationActions.removeNotification, this.notification);
        this.visible = false;
        window.setTimeout(() => { this.ready = true; this.processNext(); }, 1000);
      },
    }
  };
</script>

<style scoped>
    .notify-wrapper {
        width: 100%;
        background: transparent;
        position: absolute;
        top: 20px;
        transition: 1s ease all;
        height: 30px;
    }

    .visible {
        transition: 1s ease all;
        top: 50px;
    }

    .notify-container {
        height: 30px;
        width: 80%;
        min-width: 300px;

        border: 1px solid transparent;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 5px;
        border-top: none;
        margin: auto;
    }

    .text-col {
        flex: 1;
    }

    .col {
        justify-content: center;
    }

    .text {
        text-align: center;
    }

    .error {
        background: rgba(169, 0, 0, 0.5);
        border-color: darkred;
    }

    .success {
        background: rgba(0, 150, 0, 0.5);
        border-color: darkgreen;
    }

    .cross {
        margin: 0 5px;
        cursor: pointer;
    }
</style>
